angular.module('jv.AppList.Controller',[])
    .controller('AppList', ['$scope', '$rootScope', 'application', function($scope, $rootScope,application){
        $rootScope.loading = true;
        $scope.page = 0;
        $scope.applicationsCount;
        $scope.pageCount = 0;
        $scope.firstResult = 0;
        $scope.lastResult = 0;
        $scope.showVideoLink = false;
        $scope.showOnboardingLink = false;
        getList($scope.page);

        application.getOnboardingInProcess().then(function(hasOnboardingInProcess){
            $scope.showOnboardingLink = hasOnboardingInProcess;
        });

        function getVideoList() {
            application.getVideoList(function(result) {
                if (result.data.videoInterviewsCount !== 0) {
                    $scope.showVideoLink = true;
                }
            }, function() {
                $rootScope.loading = false;
            });
        }

        $scope.paginate = function(ifForward) {
            var page = $scope.page;
            page = ifForward ? page + 1 : page - 1;
            if (page < 0 || page >= $scope.pageCount) {
                return false;
            }
            $rootScope.loading = true;
            $scope.page = page;
            getList(page);
        };

        function getList(page) {
            $rootScope.loading = true;
            getVideoList();
            application.getList(page, function(response) {
                var res = response.data;
                $scope.list = [];
                if (res.error) {
                    $rootScope.loading = false;
                    return;
                }
                $rootScope.loading = false;
                $scope.list = res.bean;
                $scope.applicationsCount = res.resultCount;
                $scope.pageCount = res.pageCount;
                $scope.firstResult = res.firstResult;
                $scope.lastResult = res.lastResult;

            }, function() {
                $rootScope.loading = false;
            });
        }
    }]);